import { render, staticRenderFns } from "./CancelationPolicyList.vue?vue&type=template&id=4289b478&scoped=true&"
import script from "./CancelationPolicyList.vue?vue&type=script&lang=js&"
export * from "./CancelationPolicyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4289b478",
  null
  
)

export default component.exports